const length = require('./length')

// lengthMinusOne
module.exports = x => length(x) - 1
